
export class Item {
  id: string;
  name: string;
  description: string;
  picture: string;
  tags: string[];
  price: number;
  stock_count: number;

  constructor(id: string, name: string, description: string, picture: string, tags: string[], price: number, stock_count: number) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.picture = picture;
    this.tags = tags;
    this.price = price;
    this.stock_count = stock_count;
  }

  static fromApiResponse(apiResponse: any): Item {
    const { id, name, description, picture, tags, price, stock_count: stockCount } = apiResponse;
    return new Item(id, name, description, picture, tags, price, stockCount);
  }

  static parseItems(apiResponseArray: any[]): Item[] {
    if (Array.isArray(apiResponseArray)) {
      return apiResponseArray.map(itemData => Item.fromApiResponse(itemData));
    }
    return [];
  }

  toApiObject(): any {
    return {
      name: this.name,
      description: this.description,
      picture: this.picture,
      tags: this.tags,
      price: this.price,
      stock_count: this.stock_count,
    };
  }

  toJSON(): string {
    return JSON.stringify({
      id: this.id,
      name: this.name,
      description: this.description,
      picture: this.picture,
      tags: this.tags,
      price: this.price,
      stock_count: this.stock_count,
    });
  }

  static fromJSON(json: string): Item {
    const { id, name, description, picture, tags, price, stock_count: stockCount } = JSON.parse(json);
    return new Item(id, name, description, picture, tags, price, stockCount);
  }

  toString(): string {
    return `Item { id: ${this.id}, name: ${this.name}, description: ${this.description}, picture: ${this.picture}, tags: [${this.tags.join(', ')}], price: ${this.price}, stockCount: ${this.stock_count} }`;
  }
}
